/** Object IDs of Azure Dynamic Email Groups stored in Quanta's Azure tenant. Mirrors ADGroup.cs on the API side. */
export const WARRANTY_MANAGERS = "f59d207b-c178-4f27-a475-6c0545d9418a";
export const SC_SENIOR_MANAGERS = "47782dc5-8958-4fd7-8850-3ee8573e4345";
export const SC_MANAGER_SOURCING = "3aefba7d-35fc-436f-abfb-0c6d87c0ae07";
export const SC_MANAGER_QUALITY = "dd479876-d5cd-4e2c-b13c-4ee3de6ca627";
export const PC_PROJECT_ENGINEERS = "ea657cf0-3580-4d3d-9dc4-6d5c72b1d52a";
export const PC_PROJECT_ENGINEERING = "54d8236b-d324-40af-a0a8-6427681deea8";
export const QUALITY_SYSTEM_ANALYSTS = "859ab885-da2b-48af-8a41-295aefd561e8";
export const QUALITY_ASSISTANTS = "7486b6e2-6139-452d-b46d-8623a8cb7034";
export const QUALITY_SYSTEMS_MANAGER = "86d5b645-005c-4b44-bd55-171ce45e0ec0";
export const PROJECT_MANAGER = "c9ccdedb-197f-4e1a-94cb-41d385aa74e2";
export const SITE_MANAGER = "b9ffe5a4-07f0-40fe-9025-a22293be8d6d";
export const DIRECTOR_CONSTRUCTION_WIND = "42c41b05-def5-43ba-88b6-fdf94c6f64a1";
export const DIRECTOR_CONSTRUCTION_SOLAR = "c24849b4-c0f0-4f78-a092-235a46c98ebb";
export const DIRECTOR_ENGINEERING = "250b745b-314b-4cab-9c50-f95846f7bed3";
export const VP_WIND = "ae8a05f7-b7f1-4f71-84bc-1aa450d48a88";
export const VP_SOLAR = "08ecf7e7-cccc-480b-bf6f-bd2c3790f9ec";
export const VP_CONSTRUCTION_PRECONSTRUCTION = "af22c37e-e0c0-4a0e-9201-a79d51eeb330";
export const CHIEF_LEGAL_OFFICER = "240fdbc3-93ef-4cb6-8036-5522c3abe0c7";
export const QUALITY_SYSTEM_ASSISTANTS = "26cb3719-47ad-44d7-aa20-8145728f5b15";
export const QUALITY_DATA_ANALYST = "63fdf600-21b8-4945-8ed4-5bd5e2852df1";
export const SC_ENGINEER_QUALITY = "8cfecae2-76f5-4287-8417-da14102940ba";
export const CHIEF_SUPPLY_CHAIN_OFFICER = "148730a6-9937-42e9-8de8-554d038b4125";
export const DIRECTOR_SSM_IW = "60cc646c-fb37-46b2-8bd4-d801c7b5fa09";
export const SENIOR_PROJECT_MANAGER = "117dd2c5-9bfd-4097-a7e2-a2cc90d5cbbf";
export const VP_SAFETY_QUALITY = "f4def371-84b4-4a47-be46-719ebab8eb78";
export const CHIEF_ENTERPRISE_RISK_OFFICER = "bbdb61ce-91f8-43dd-949a-1d019fd25469";
export const CIVIL_ENGINEER = "d8da0425-31aa-4853-94f6-7b3572f14bd7";
export const PROJECT_CIVIL_ENGINEER = "74a724d1-90fc-4b2c-81b0-6cc367c11cc1";
export const SENIOR_CIVIL_ENGINEER = "7b53028c-b0aa-488c-9c2d-27fb22fe63fa";
export const QUALITY_SUPT = "2149ea48-c687-4961-9686-3df70c79d664";
export const VP_ENGINEERING = "f53c7b91-bd46-4b8b-ba40-be6a920e505e";
export const VP_SOLAR_STORAGE = "26620be7-df1c-474b-a111-b29aaa01ba2b";
export const DIRECTOR_CONSTRUCTION_STORAGE = "dc87a53e-3150-4664-9255-40862e631edf";
export const ENERGYLINK_USERS = "3351c8cc-9ede-44ad-abe3-2cd15f8855e7";
